import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { fuseAnimations } from "@fuse/animations";
import { FuseTranslationLoaderService } from "@fuse/services/translation-loader.service";
import { AlarmModel } from "app/models/alarm.model";
import { ProjectModel } from "app/models/project.model";
import { describeAlarmLimits } from "app/shared/alarm-period-rendering";
import { ToastrService } from "ngx-toastr";
import { locale as catalan } from "../i18n/ca";
import { locale as english } from "../i18n/en";
import { locale as spanish } from "../i18n/es";

@Component({
    selector: "app-alarm-list",
    templateUrl: "./alarm-list.component.html",
    styleUrls: ["./alarm-list.component.scss"],
    animations: fuseAnimations,
    standalone: false,
})
export class AlarmListComponent implements OnInit {
    @Input() alarms: AlarmModel[];
    @Input() project: ProjectModel;
    private dialogRef: any;
    displayedColumns = ["name", "field", "window", "threshold", "limit", "severity", "buttons"];

    @Output()
    rowClick = new EventEmitter<AlarmModel>();

    @Output()
    deleteClick = new EventEmitter<AlarmModel>();

    @Output()
    duplicateClick = new EventEmitter<AlarmModel>();

    constructor(
        private _fuseTranslationLoaderService: FuseTranslationLoaderService,
        private _matDialog: MatDialog,
        private toastr: ToastrService,
        private router: Router,
    ) {
        this._fuseTranslationLoaderService.loadTranslations(english, spanish, catalan);
    }

    ngOnInit() {}

    formatLimit(alarm: AlarmModel): string {
        return describeAlarmLimits(alarm, this.project);
    }

    // public editAlarm(alarm: AlarmModel) {
    //     const data = { alarm, device: this.device };
    //     this.dialogRef = this._matDialog.open(DeviceAlarmComponent, { data });
    //     this.dialogRef.afterClosed().subscribe(result => {
    //         if (!result) {
    //             return;
    //         }
    //         const alarm = result.alarm;
    //         this.alarmService.edit(this.device.id, alarm).subscribe(
    //             data => {
    //                 this.loadData();
    //             },
    //             error => {
    //                 console.log(error);
    //                 this.toastr.error('Error: ' + error.message);
    //             },
    //         );
    //     });
    // }

    // public addAlarm() {
    //     const data = { device: this.device };
    //     this.dialogRef = this._matDialog.open(DeviceAlarmComponent, { data });
    //     this.dialogRef.afterClosed().subscribe(result => {
    //         if (!result) {
    //             return;
    //         }
    //         const alarm: AlarmModel = result.alarm;
    //         this.alarmService.create(this.device.id, alarm).subscribe(
    //             data => {
    //                 this.loadData();
    //             },
    //             error => {
    //                 console.log(error);
    //                 this.toastr.error('Error: ' + error.message);
    //             },
    //         );
    //     });
    // }

    // public deleteAlarm(alarm: AlarmModel) {
    //     this.alarmService.delete(this.device.id, alarm.id).subscribe(
    //         success => {
    //             this.loadData();
    //         },
    //         error => {
    //             console.log(error);
    //             if (error.error.statusCode === 404) {
    //                 this.router.navigate(['/devices']);
    //             }
    //         },
    //     );
    // }

    onDeleteClick(alarm: AlarmModel) {
        this.deleteClick.emit(Object.assign(new AlarmModel(), alarm));
    }

    onDuplicateClick(alarm: AlarmModel) {
        this.duplicateClick.emit(Object.assign(new AlarmModel(), alarm));
    }

    onClick(alarm: AlarmModel) {
        this.rowClick.emit(Object.assign(new AlarmModel(), alarm));
    }
}
